import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "../../Style.css";
import { toast } from "react-toastify";

const ResetPassword = () => {
  const url = process.env.REACT_APP_BACKEND_URL 
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { token } = useParams(); // Token passed as a URL parameter
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Validate passwords
    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      setLoading(false);
      return;
    }

    try {
      // Send token as part of the URL parameter
      const response = await axios.post(`${url}/auth/reset-password/${token}`, {
        password,
      });

      if (response.data.success) {
        toast.success("Password reset successfully. Redirecting to login...");
        setTimeout(() => {
          navigate("/");
        }, 1000); // Redirect after 3 seconds
      }
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
          "Failed to reset password. Please try again."
      );
    } finally {
      setPassword("");
      setConfirmPassword("");
      setLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 auth-bg">
      <div
        className="card p-4 shadow-lg"
        style={{
          maxWidth: "400px",
          width: "100%",
          borderRadius: "15px",
          backgroundColor: "#fff",
          color: "#333",
        }}
      >
        <div className="text-center mb-4">
          <h3 className="mt-2" style={{ fontWeight: "600" }}>
            Reset Password
          </h3>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">
              <i
                className="bi bi-lock-fill me-2"
                style={{ color: "#2a5298" }}
              ></i>
              New Password
            </label>
            <input
              type="password"
              className="form-control shadow-sm"
              id="password"
              name="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ borderRadius: "10px" }}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="confirmPassword" className="form-label">
              <i
                className="bi bi-lock-fill me-2"
                style={{ color: "#2a5298" }}
              ></i>
              Confirm Password
            </label>
            <input
              type="password"
              className="form-control shadow-sm"
              id="confirmPassword"
              name="confirmPassword"
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              style={{ borderRadius: "10px" }}
            />
          </div>
          <div className="d-flex justify-content-center">
            <button
              type="submit"
              className="btn btn-primary btn-lg shadow-sm"
              disabled={loading}
              aria-disabled={loading}
              style={{
                borderRadius: "25px",
                backgroundColor: "#2a5298",
                border: "none",
                width: "100%",
              }}
            >
              {loading ? "Resetting..." : "Reset Password"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
